<template>
  <span v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card data-testid="counts-page">
      <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
        <v-row>
          <v-col cols="12" v-if="company && company.multicurrency_cashboxes"
            class="d-flex flex-wrap justify-center pb-4">
            <v-chip v-for="currency_account in currency_accounts" :key="currency_account.id"
              class="ma-1 font-weight-bold" :color="(parseFloat(currency_account.cash) || 0) >= 0 ? 'info' : 'error'" text-color="white">
              {{ (parseFloat(currency_account.cash) || 0).toFixed(2) }}
              {{ findCashboxName(currency_account.company_cashbox_id, currency_account.currency_id) }}
            </v-chip>
          </v-col>
          <v-col cols="12" v-else>
            <h2 class="mb-2">
              {{ $t("counts.in_count") }}:
              <v-chip :color="(parseFloat(account.cash) || 0) >= 0 ? 'success' : 'error'" text-color="white">
                {{ (parseFloat(account.cash) || 0).toFixed(1) }}{{ currency }}
              </v-chip>
            </h2>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-toolbar v-if="!isMobile" text :color="$vuetify.theme.dark ? '' : 'white'" align-content-center
                class="start-tour-counts-1">
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line
                  clearable hide-details data-testid="counts-search"></v-text-field>
                <v-spacer></v-spacer>
                <v-btn small color="success" to="/counts/new">
                  {{
                    $t("counts.add_count")
                  }}
                  <v-icon class="ml-1">mdi-plus-circle-outline</v-icon>
                </v-btn>
                <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
                  }/${$root.$i18n.locale}/categories/6`" target="_blank">
                  <v-icon>mdi-help-circle</v-icon>
                </v-btn>
              </v-toolbar>
              <v-toolbar v-else text :color="$vuetify.theme.dark ? '' : 'white'" height="100px" align-content-center
                class="start-tour-counts-1">
                <v-flex md12 class="text-center">
                  <v-text-field v-model="search" class="mb-3" append-icon="mdi-magnify" :label="$t('custom.search')"
                    single-line clearable hide-details></v-text-field>
                  <v-btn small color="success" to="/counts/new">{{
                    $t("counts.add_count")
                    }}</v-btn>
                </v-flex>
              </v-toolbar>
              <v-data-table :headers="company && company.multicurrency_cashboxes ? headers_with_currency : headers"
                :items="counts" :search="search" :loading="isLoading" :loading-text="$t('custom.loading_table')"
                :items-per-page="20" :dense="isMobile" mobile-breakpoint="100" :sort-by="['created_at']"
                :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([20, 50, 100])">
                <template slot="item" slot-scope="props">
                  <tr :class="props.item.operation && props.item.sum < 0
                    ? 'red--text'
                    : ''
                    ">
                    <td class="text-center">{{ props.item.id }}</td>
                    <td class="text-center" nowrap>
                      {{ returnDate(props.item.created_at) }}
                    </td>
                    <td class="text-center" nowrap>
                      <v-icon v-if="!isForeignBranchCount(props.item)" class="mr-2" @click="editCount(props.item)">
                        mdi-pencil-outline
                      </v-icon>
                      <!-- Чужефилиальная строка: правка скоуплена филиалом (api#565),
                           карандаш дал бы немой 404 — замок с подсказкой, как в
                           admin/users (vue#373). Ячейка остаётся на месте (урок vue#369). -->
                      <v-icon v-else class="mr-2" color="grey lighten-1" v-tooltip="{
                        content: $t('errors.foreign_branch_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-lock-outline
                      </v-icon>
                    </td>
                    <td class="text-center">
                      {{ translateCategory(props.item.group) }}
                    </td>
                    <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                      {{ findCashboxName(props.item.company_cashbox_id, props.item.currency_id) }}
                    </td>
                    <td class="text-center">{{ props.item.description }}</td>
                    <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                      <span :title="$t('counts.last_balance') + ': ' + props.item.last_balance" style="cursor: pointer;"
                        @click="showLastBalanceDialog = true, last_balance = props.item.last_balance">
                        {{ props.item.sum }}{{ findCurrencySymbol(props.item.currency_id) }}
                      </span>
                      <span
                        v-if="props.item.rate && (props.item.rate != 1 && props.item.rate != 0) && props.item.rate != null">
                        ({{ props.item.rated_sum }})
                      </span>
                    </td>
                    <td v-else class="text-center">
                      <span :title="$t('counts.last_balance') + ': ' + props.item.last_balance" style="cursor: pointer;"
                        @click="showLastBalanceDialog = true, last_balance = props.item.last_balance">
                        {{ props.item.sum }}{{ currency }}
                      </span>
                    </td>
                    <td class="text-center" v-if="props.item.operation">
                      <v-icon class="text-center" style="color: green">
                        mdi-plus-circle-outline
                      </v-icon>
                    </td>
                    <td class="text-center" v-if="!props.item.operation">
                      <v-icon class="text-center" style="color: tomato">
                        mdi-minus-circle-outline
                      </v-icon>
                    </td>
                    <td class="text-center" v-if="props.item.cash">
                      <v-icon class="text-center" color="success" v-tooltip="{
                        content: $t('tooltips.cash_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-cash
                      </v-icon>
                      <v-icon @click="toClientCard(props.item)" :style="clientCardCursor(props.item)" v-if="props.item.client_balance" class="text-center" color="error" v-tooltip="{
                        content: $t('money.client_balance'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-account-arrow-right
                      </v-icon>
                      <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                        mdi-alpha-y-circle
                      </v-icon>
                      <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                        mdi-alpha-s-circle-outline
                      </v-icon>
                    </td>
                    <td class="text-center" v-else-if="props.item.cashless">
                      <v-icon class="text-center" color="warning" v-tooltip="{
                        content: $t('tooltips.terminal_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-contactless-payment-circle-outline
                      </v-icon>
                      <v-icon @click="toClientCard(props.item)" :style="clientCardCursor(props.item)" v-if="props.item.client_balance" class="text-center" color="error" v-tooltip="{
                        content: $t('money.client_balance'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-account-arrow-right
                      </v-icon>
                      <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                        mdi-alpha-y-circle
                      </v-icon>
                      <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                        mdi-alpha-s-circle-outline
                      </v-icon>
                    </td>
                    <td class="text-center" v-else-if="props.item.entity">
                      <v-icon class="text-center" color="secondery" v-tooltip="{
                        content: $t('tooltips.entity_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-bank
                      </v-icon>
                      <v-icon @click="toClientCard(props.item)" :style="clientCardCursor(props.item)" v-if="props.item.client_balance" class="text-center" color="error" v-tooltip="{
                        content: $t('money.client_balance'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-account-arrow-right
                      </v-icon>
                      <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                        mdi-alpha-y-circle
                      </v-icon>
                      <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                        mdi-alpha-s-circle-outline
                      </v-icon>
                    </td>
                    <td class="text-center" v-else-if="props.item.cash_card">
                      <v-icon class="text-center" color="info" v-tooltip="{
                        content: $t('money.card_to_card'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-credit-card-check-outline
                      </v-icon>
                      <v-icon @click="toClientCard(props.item)" :style="clientCardCursor(props.item)" v-if="props.item.client_balance" class="text-center" color="error" v-tooltip="{
                        content: $t('money.client_balance'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-account-arrow-right
                      </v-icon>
                      <v-icon v-if="props.item.yandex_pay" class="text-center" color="error" :title="$t('yandex_pay.title')">
                        mdi-alpha-y-circle
                      </v-icon>
                      <v-icon v-if="props.item.stripe" class="text-center" color="primary" :title="$t('stripe_payment.title')">
                        mdi-alpha-s-circle-outline
                      </v-icon>
                    </td>
                    <!-- Пятая ветка обязательна: платёж «с баланса клиента» не выставляет
                         НИ ОДНОГО из четырёх флагов типа, и без неё ячейка не рендерилась
                         вовсе — строка съезжала влево на одну колонку, а галочка «Проведён»
                         оказывалась под «Источником» (найдено USER 28.08.2026). -->
                    <td class="text-center" v-else>
                      <v-icon @click="toClientCard(props.item)" :style="clientCardCursor(props.item)" v-if="props.item.client_balance"
                        class="text-center" color="error" v-tooltip="{
                          content: $t('money.client_balance'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                        mdi-account-arrow-right
                      </v-icon>
                      <span v-else> - </span>
                    </td>
                    <td class="text-center">
                      <router-link v-if="props.item.contractor_id"
                        :to="{ path: `/contractors/${props.item.contractor_id}` }">
                        {{ findContractorName(props.item.contractor_id) }}
                      </router-link>
                      <span v-else> - </span>
                    </td>
                    <td class="text-left" nowrap v-if="
                      props.item.booking_id &&
                      props.item.car_id &&
                      props.item.car_code
                    ">
                      <p>
                        {{ $t("bookings.booking") }}:
                        <router-link :to="{ path: `/bookings/${props.item.booking_id}` }">
                          {{ props.item.booking_id }}
                        </router-link>
                      </p>
                      <p>
                        {{ $t("custom.car") }}:
                        <router-link :to="{ path: `/cars/${props.item.car_id}` }">
                          {{ props.item.car_code }}
                        </router-link>
                      </p>
                    </td>
                    <td class="text-center" v-else-if="props.item.car_id && props.item.car_code">
                      <router-link :to="{ path: `/cars/${props.item.car_id}` }">{{ props.item.car_code }}</router-link>
                    </td>
                    <td class="text-center" v-else-if="props.item.yandex_pay || props.item.stripe">
                      <router-link :to="{ path: `/clients/${props.item.client_id}` }">
                          {{ $t("bookings.client") }}
                        </router-link>
                    </td>
                    <td class="text-center" v-else-if="props.item.source">
                      {{ translateCountSource(props.item.source) }}
                    </td>
                    <td class="text-center" v-else-if="props.item.debt_id">
                      {{ $t("debts.debt") }} {{ $t("custom.number")
                      }}{{ props.item.debt_id }}
                    </td>
                    <td class="text-center" v-else-if="props.item.agent_id">
                      {{ $t("agents.agent") }} {{ $t("custom.number") }}
                      <router-link :to="{ path: `/agent_card/${props.item.agent_id}` }">
                        {{ props.item.agent_id }}
                      </router-link>
                    </td>
                    <td class="text-center" v-else-if="props.item.investor_id">
                      <router-link :to="{ path: `/investors/${props.item.investor_id}` }">{{ $t("employers.partner") }}
                        {{
                          $t("custom.number")
                        }}{{ props.item.investor_id }}</router-link>
                    </td>
                    <td class="text-center" v-else>-</td>
                    <td class="text-center">
                      <v-icon v-if="props.item.completed" color="success" v-tooltip="{
                        content: $t('counts.completed'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }" @click="completedTooltipDialog(props.item)">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-else color="error" v-tooltip="{
                        content: $t('counts.not_completed'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }" @click="processedCount(props.item)">
                        mdi-alert-circle-outline
                      </v-icon>
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  {{ $t("custom.no_data_in_table") }}
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                  {{ $t("tables.no_search_result", { msg: search }) }}
                </v-alert>
              </v-data-table>
            </v-card>
          </v-col>
          <v-col cols="12" class="mt-5">
            <h2 class="mb-2">{{ $t("counts.daily_kass") }}</h2>
            <v-card>
              <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
                <v-spacer></v-spacer>
                <v-text-field v-model="search_cashbox" append-icon="mdi-magnify" :label="$t('custom.search')"
                  single-line clearable hide-details></v-text-field>
              </v-toolbar>
              <v-data-table :headers="headers_cashboxes" :items="user_cashbox" :search="search_cashbox" dense
                :loading-text="$t('custom.loading_table')" :items-per-page="7" mobile-breakpoint="100"
                :sort-by="['created_at']" :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([7, 14, 50, 100])">
                <template slot="item" slot-scope="props">
                  <tr>
                    <td class="text-center">{{ props.item.id }}</td>
                    <td class="text-center">
                      {{ formatCreatedAt(props.item.created_at) }}
                    </td>
                    <td class="text-center" v-if="company && company.multicurrency_cashboxes">
                      <span v-for="(balance, company_cashbox_id) in props.item.currency_balances"
                        :key="company_cashbox_id">
                        {{ findCashboxName(company_cashbox_id) }}: {{ parseFloat(balance).toFixed(2) }}
                      </span>
                    </td>
                    <td class="text-center" v-else>
                      {{ props.item.account }}{{ currency }}
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  {{ $t("custom.no_data_in_table") }}
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                  {{ $t("tables.no_search_result", { msg: search }) }}
                </v-alert>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="editDialog" :retain-focus="false" persistent :fullscreen="isMobile ? true : false"
      max-width="1000px">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("custom.editing") }}</span>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-container grid-list-md :style="isMobile ? 'padding: 5px !important;' : ''">
            <v-container :style="isMobile ? 'padding: 5px !important;' : ''">
              <v-layout row wrap>
                <v-flex xs12 md2>
                  <!-- Сумма редактируема ТОЛЬКО у непроведённого платежа — зеркало
                       CompanyCounts и counts#update (сервер вычёркивает sum у completed).
                       Безусловный readonly оставлял ошибочный отложенный платёж в личной
                       кассе неисправимым вовсе: отмены на этом экране нет, destroy снят. -->
                  <v-text-field :readonly="editedCount.completed == true" v-model.number="editedCount.sum" :label="$t('custom.amount')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md5>
                  <v-combobox v-model="selected_count" :items="counts_groups" item-text="text" item-value="value"
                    :label="$t('custom.select_group')"></v-combobox>
                </v-flex>
                <v-flex xs12 sm4 md5>
                  <v-text-field v-if="!showCarSearch" :label="$t('custom.car_long', { msg: object_name_for_label })"
                    :placeholder="$t('custom.car_long', { msg: object_name_for_label })" :value="editedCount.car_code"
                    @click="showCarSearch = true"></v-text-field>
                  <v-autocomplete v-if="showCarSearch" v-model="selected_car" item-text="code" item-value="id"
                    :loading="isLoadingCars" :search-input.sync="searchCar" text hide-no-data hide-details clearable
                    :label="$t('custom.select_car')" :items="cars" return-object>
                  </v-autocomplete>
                </v-flex>
                <v-flex md12>
                  <v-autocomplete v-model="editedCount.contractor_id" item-text="short_name" item-value="id" clearable
                    :items="contractors" :label="$t('contractors.select_contractor')" hide-no-data
                    hide-details></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-textarea v-model="editedCount.description" :label="$t('counts.count_description')"
                    :placeholder="$t('counts.count_description_plc')" rows="1" auto-grow></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false">{{
            $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="saveCount()">{{
            $t("custom.save")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showProcessedInfoDialog" :retain-focus="false" persistent max-width="500px">
      <v-card>
        <v-card-title v-if="workers && workers.length > 0">
          {{ `${$t('counts.completed')}: ${formatCompletedAt(editedCount.completed_at)},
          ${findWorkersName([editedCount.completed_by])}` }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showProcessedInfoDialog = false, editedCount = {}">{{ $t("custom.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showLastBalanceDialog" :retain-focus="false" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showLastBalanceDialog = false, last_balance = 0">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>{{ $t("counts.last_balance") }}: {{ last_balance }}</v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import PullToRefresh from "pulltorefreshjs";
import clientCardLinkMixin from "@/mixins/clientCardLinkMixin";
import rentalObjectMixin from "@/mixins/rentalObjectMixin";

export default {
  mixins: [clientCardLinkMixin, rentalObjectMixin],
  data() {
    return {
      counts: [],
      counts_groups: [
        { text: this.$t("groups_counts.repair"), value: "Ремонт" },
        { text: this.$t("groups_counts.service"), value: "Обслуживание" },
        { text: this.$t("groups_counts.parts"), value: "Запчасти" },
        { text: this.$t("groups_counts.insurance_main"), value: "Страховка" },
        {
          text: this.$t("groups_counts.common_expences"),
          value: "Накладные расходы",
        },
        {
          text: this.$t("groups_counts.transport_expences"),
          value: "Транспортные расходы",
        },
        { text: this.$t("groups_counts.tax"), value: "Налоги" },
        { text: this.$t("groups_counts.fines_main"), value: "Штрафы" },
        {
          text: this.$t("groups_counts.rent_property"),
          value: "Аренда имущества",
        },
        {
          text: this.$t("groups_counts.clean_main"),
          value: "Мойка автомобилей",
        },
        { text: this.$t("groups_counts.fuel_main"), value: "Топливо" },
        { text: this.$t("groups_counts.ads"), value: "Реклама" },
        {
          text: this.$t("groups_counts.sell_property"),
          value: "Продажа имущества",
        },
        {
          text: this.$t("groups_counts.buy_property"),
          value: "Покупка имущества",
        },
        {
          text: this.$t("groups_counts.other_expences"),
          value: "Прочие расходы",
        },
        {
          text: this.$t("groups_counts.other_incomes"),
          value: "Прочие доходы",
        },
      ],
      user_cashbox: [],
      headers_cashboxes: [
        { text: this.$t("custom.id"), align: "center", value: "id" },
        { text: this.$t("custom.date"), value: "created_at", align: "center" },
        { text: this.$t("custom.counts"), value: "account", align: "center" },
      ],
      contractors: [],
      cars: [],
      search: "",
      user: [],
      account: {
        cash: 0,
        cashless: 0,
      },
      last_balance: 0,
      showLastBalanceDialog: false,
      editedCount: {},
      selected_car: null,
      selected_count: null,
      showCarSearch: false,
      isLoadingCars: false,
      searchCar: null,
      showProcessedInfoDialog: false,
      headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
        { text: this.$t("custom.group"), value: "group", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.operation"),
          value: "operation",
          align: "center",
        },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
        {
          text: this.$t("contractors.contractor"),
          value: "contractor_id",
          align: "center",
        },
        { text: this.$t("custom.source"), sortable: false, align: "center" },
        { text: this.$t("counts.completed"), value: "completed", align: "center" },
      ],
      headers_with_currency: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
        { text: this.$t("custom.group"), value: "group", align: "center" },
        { text: this.$t("companies.count"), value: "company_cashbox_id", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        {
          text: this.$t("custom.operation"),
          value: "operation",
          align: "center",
        },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
        {
          text: this.$t("contractors.contractor"),
          value: "contractor_id",
          align: "center",
        },
        { text: this.$t("custom.source"), sortable: false, align: "center" },
        { text: this.$t("counts.completed"), value: "completed", align: "center" },
      ],
      workers: [],
      pagination: { sortBy: "created_at", descending: true },
      search_cashbox: "",
      editDialog: false,
      isMobile: false,
      isLoading: true,
      error: "",
    };
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/user_cashbox`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.user = response.data.user;
          // set user data to store
          this.$store.commit("setCurrentUser", response.data.user);
          this.account = response.data.account;
          this.user_cashbox = response.data.user_cashbox;
          console.log(this.user_cashbox);
          this.counts = [];
          response.data.counts.data.forEach((count) => {
            this.counts.push(count.attributes);
          });
          this.contractors = [];
          response.data.contractors.data.forEach((contractor) => {
            this.contractors.push(contractor.attributes);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.load_user"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    searchCar(val) {
      // Items have already been loaded
      if (this.cars.length > 0) return;

      // Items have already been requested
      if (this.isLoadingCars) return;

      this.isLoadingCars = true;

      // Lazily load input items
      this.axios
        .get("/api/v1/cars", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.cars.push(element.attributes);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.load_cars"));
          console.log(error);
        })
        .finally(() => (this.isLoadingCars = false));
    },
  },
  computed: {
    company() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company;
      }
      return undefined;
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id) {
            cashboxes.push(cashbox);
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    currency_accounts() {
      if (this.$store.getters.getCurrentUser && this.$store.getters.getCurrentUser.currency_accounts) {
        let accounts = [];
        this.$store.getters.getCurrentUser.currency_accounts.forEach((account) => {
          if (this.active_company_cashboxes.find((cashbox) => (cashbox.id == account.company_cashbox_id || cashbox.currency_id == account.currency_id))) {
            accounts.push(account);
          }
        });
        return accounts;
      } else {
        return [];
      }
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
  },
  methods: {
    // Личная касса скоуплена по ТЕНАНТУ (api#565): наличные переезжают вместе с
    // сотрудником, поэтому в журнале законно живут строки соседнего филиала. А
    // правка на сервере скоуплена филиалом — действие по чужой строке вернёт 404,
    // и предлагать его нельзя. Зеркало admin/users (vue#373). Предикат намеренно
    // консервативен: нет company_id или компания не загружена — не блокируем,
    // сервер всё равно последняя инстанция.
    isForeignBranchCount(count) {
      const own = this.company && this.company.id;
      return !!(own && count && count.company_id && count.company_id !== own);
    },
    editCount(count) {
      if (this.isForeignBranchCount(count)) {
        this.$notify(this.$t("errors.foreign_branch_count"), "", "warning");
        return;
      }
      this.editDialog = true;
      this.axios
        .get(`/api/v1/counts/${count.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.editedCount = response.data;
          let group_text = this.translateCategory(this.editedCount.group);

          this.selected_count = {
            text: group_text,
            value: this.editedCount.group,
          };
          // this.selected_car = this.editedCount.car_id
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.load_cashboxes"));
          console.log(error);
        });
    },
    translateCategory(category) {
      let group_text = "";
      switch (category) {
        case "Оплата аренды":
          group_text = this.$t("groups_counts.rent");
          break;
        case "Доплата за доставку":
          group_text = this.$t("groups_counts.delivery");
          break;
        case "Доплата за приём":
          group_text = this.$t("groups_counts.checkout");
          break;
        case "Доплата за топливо":
          group_text = this.$t("groups_counts.fuel");
          break;
        case "Доплата за мойку":
          group_text = this.$t("groups_counts.clean");
          break;
        case "Доплата за оборудование":
          group_text = this.$t("groups_counts.equipment");
          break;
        case "Доплата за дополнительное время":
          group_text = this.$t("groups_counts.add_time");
          break;
        case "Доплата за повреждения":
          group_text = this.$t("groups_counts.damages");
          break;
        case "Доплата за штрафы":
          group_text = this.$t("groups_counts.fines");
          break;
        case "Доплата за другое":
          group_text = this.$t("groups_counts.other");
          break;
        case "Доплата за превышение пробега":
          group_text = this.$t("groups_counts.mileage");
          break;
        case "Доплата за страховку":
          group_text = this.$t("groups_counts.insurance");
          break;
        case "Доплата за доп водителей":
          group_text = this.$t("groups_counts.add_drivers");
          break;
        case "Ремонт":
          group_text = this.$t("groups_counts.repair");
          break;
        case "Обслуживание":
          group_text = this.$t("groups_counts.service");
          break;
        case "Запчасти":
          group_text = this.$t("groups_counts.parts");
          break;
        case "Страховка":
          group_text = this.$t("groups_counts.insurance_main");
          break;
        case "Накладные расходы":
          group_text = this.$t("groups_counts.common_expences");
          break;
        case "Транспортные расходы":
          group_text = this.$t("groups_counts.transport_expences");
          break;
        case "Налоги":
          group_text = this.$t("groups_counts.tax");
          break;
        case "Штрафы":
          group_text = this.$t("groups_counts.fines_main");
          break;
        case "Аренда имущества":
          group_text = this.$t("groups_counts.rent_property");
          break;
        case "Мойка автомобилей":
          group_text = this.$t("groups_counts.clean_main");
          break;
        case "Топливо":
          group_text = this.$t("groups_counts.fuel_main");
          break;
        case "Реклама":
          group_text = this.$t("groups_counts.ads");
          break;
        case "Зарплата":
          group_text = this.$t("groups_counts.salary");
          break;
        case "Залог":
          group_text = this.$t("groups_counts.deposit");
          break;
        case "Внутренние переводы":
          group_text = this.$t("groups_counts.internal");
          break;
        case "Выплаты партнёрам":
          group_text = this.$t("groups_counts.partners_payments");
          break;
        case "Продажа имущества":
          group_text = this.$t("groups_counts.sell_property");
          break;
        case "Покупка имущества":
          group_text = this.$t("groups_counts.buy_property");
          break;
        case "Прочие расходы":
          group_text = this.$t("groups_counts.other_expences");
          break;
        case "Прочие доходы":
          group_text = this.$t("groups_counts.other_incomes");
          break;
        case "Сервисные сборы":
          group_text = this.$t("groups_counts.service_fees");
          break;
        case "Пополнение баланса клиента":
          group_text = this.$t("groups_counts.top_up_client_balance");
          break;
        case "Выплаты агентам":
          group_text = this.$t("groups_counts.agent_payments");
          break;
      }
      return group_text;
    },
    findCashboxName(company_cashbox_id, currency_id) {
      if (company_cashbox_id != null) {
        if (this.company_cashboxes.find((cashbox) => cashbox.id == company_cashbox_id)) {
          return this.company_cashboxes.find((cashbox) => cashbox.id == company_cashbox_id).name;
        } else {
          if (this.currencies.find((currency) => currency.id == currency_id)) {
            return this.currencies.find((currency) => currency.id == currency_id).symbol;
          }
        }
      } else {
        return "-";
      }
    },
    translateCountSource(source) {
      let source_text = "";
      switch (source) {
        case "Касса компании":
          source_text = this.$t("counts.company_counts");
          break;
        case "Внешний перевод":
          source_text = this.$t("counts_groups.external_transfers");
          break;
        default:
          source_text = source;
          break;
      }
      return source_text;
    },
    saveCount() {
      if (this.isAdminPlus) {
        this.isLoading = true;
        let count = this.editedCount;
        let self = this;
        this.axios
          .patch(
            `/api/v1/counts/${count.id}`,
            {
              counts: {
                // Как в CompanyCounts: sum шлём всегда, сервер применяет его только
                // к непроведённым (counts#update вычёркивает sum у completed).
                sum: count.sum.toFixed(2),
                operation: count.operation,
                cashless: count.cashless,
                description: count.description,
                group: this.selected_count
                  ? this.selected_count.group
                  : count.group,
                car_id: this.selected_car ? this.selected_car.id : count.car_id,
                contractor_id: count.contractor_id,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.editDialog = false;
            let foundIndex = this.counts.findIndex(
              (element) => element.id === count.id
            );

            let count_data = response.data;
            if (this.selected_car) {
              count_data.car_code = this.selected_car.code;
            }
            console.log(count_data);
            this.counts.splice(foundIndex, 1, count_data);

            this.$notify(this.$t("counts.update_count_title"), this.$t("counts.update_count_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.update_count"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    processedCount(count) {
      if (this.isAdminPlus) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("counts.processed_payment_not_declined"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.yes"),
          cancelButtonText: this.$t("custom.no"),
        }).then((result) => {
          if (result) {
            this.isLoading = true;
            this.axios
              .post(
                `/api/v1/processed_count`,
                {
                  count_id: count.id,
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then((response) => {
                let foundIndex = this.counts.findIndex(
                  (element) => element.id === count.id
                )
                this.counts.splice(foundIndex, 1, response.data);
                let current_user = this.$store.getters.getCurrentUser;
                if (this.company.multicurrency_cashboxes && response.data.company_cashbox_id && response.data.cash && current_user && current_user.currency_accounts) {
                  let user_currency_account = current_user.currency_accounts.find((account) => account.company_cashbox_id == response.data.company_cashbox_id);
                  if (user_currency_account) {
                    // update account balance
                    if (response.data.operation) {
                      user_currency_account.cash += response.data.sum;
                    } else {
                      user_currency_account.cash -= response.data.sum;
                    }
                    current_user.currency_accounts.splice(current_user.currency_accounts.findIndex((account) => account.id == user_currency_account.id), 1, user_currency_account);
                    this.$store.commit("setCurrentUser", current_user);
                  }
                }

                if (!this.company.multicurrency_cashboxes && response.data.cash && current_user) {
                  if (response.data.operation) {
                    this.account.cash += response.data.sum;
                  } else {
                    this.account.cash -= response.data.sum;
                  }
                }

                this.$notify(this.$t("counts.update_count_title"), this.$t("counts.update_count_text"), "success");
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.update_count"));
              })
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    setCar(id) {
      if (id != null) {
        if (this.cars.find((car) => car.id == id)) {
          return this.cars.find((car) => car.id == id).code;
        }
      } else {
        return "-";
      }
    },
    getWorkersNames() {
      this.isLoadingResponsible = true;
      this.axios
        .get("/api/v1/get_workers_names_with_ids", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.workers = response.data;
        })
        .catch((error) => {
          this.setError(error, "Something went wrong in get_workers_names");
          console.log(error);
        })
        .finally(() => (this.isLoadingResponsible = false));
    },
    findWorkersName(ids) {
      let names = [];
      ids.forEach((id) => {
        this.workers.forEach((worker) => {
          if (worker.id == id) {
            names.push(worker.name);
          }
        });
      });
      return names ? names.join(", ") : "";
    },
    findContractorName(id) {
      if (id != null) {
        if (this.contractors.find((contractor) => contractor.id == id)) {
          return this.contractors.find((contractor) => contractor.id == id)
            .short_name;
        }
      } else {
        return "-";
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    completedTooltipDialog(item) {
      if (item && item.completed_at && item.completed_by) {
        this.getWorkersNames();
        this.showProcessedInfoDialog = true;
        this.editedCount = item;
      } else {
        this.showProcessedInfoDialog = false;
      }
    },
    formatCompletedAt(date) {
      if (date == null) {
        return "-";
      }
      return moment.parseZone(date).format("lll");
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("DD MMM H:mm");
    },
    returnDate(item) {
      return moment.parseZone(item).format("lll");
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
};
</script>
